import { render, staticRenderFns } from "./ShapesSideMenu.vue?vue&type=template&id=69650bce&scoped=true&"
import script from "./ShapesSideMenu.vue?vue&type=script&lang=js&"
export * from "./ShapesSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./ShapesSideMenu.vue?vue&type=style&index=0&id=69650bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69650bce",
  null
  
)

export default component.exports